
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import respuestas from './utiles-respuestas.vue';
    import detalles from './utiles-detalles.vue';
    import publicaciones from './utiles-publicaciones.vue';
    import envios from './utiles-envios.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            respuestas,
            detalles,
            publicaciones,
            envios,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public Modo: string = '';
        protected Eventos: Function[] = [];
        beforeDestroy()
        {

            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Modo = this.Controlador.Vista.Modo;
            this.Eventos.push( this.Controlador.Vista.onModo.subscribe( () =>
            {
                this.Modo = this.Controlador.Vista.Modo;
            } ) );
        }

    }
